import { render, staticRenderFns } from "./SinglePost.vue?vue&type=template&id=60811ea8&scoped=true&"
import script from "./SinglePost.vue?vue&type=script&lang=js&"
export * from "./SinglePost.vue?vue&type=script&lang=js&"
import style0 from "./SinglePost.vue?vue&type=style&index=0&id=60811ea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60811ea8",
  null
  
)

export default component.exports